/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
import ContentBlock from '../components/ContentBlock';
import GraphQLConnectedDemo from '../components/GraphQL/GraphQL-ConnectedDemo';
import GraphQLIntegratedDemo from '../components/GraphQL/GraphQL-IntegratedDemo';
import GraphQLLayout from '../components/GraphQL/GraphQL-Layout';
import GraphQLSSRDemo from '../components/GraphQL/GraphQL-SSRDemo';
import HJBook from '../components/HJBook';
import HJCTA from '../components/HJCTA';
import HJCalendar from '../components/HJCalendar';
import HJContainer from '../components/HJContainer';
import HJContentBlock from '../components/HJContentBlock';
import HJContentBlockList from '../components/HJContentBlockList';
import HJContentBlockListIntegrated from '../components/HJContentBlockListIntegrated';
import HJContentModule from '../components/HJContentModule';
import HJCountryBlock from '../components/HJCountryBlock';
import HJData from '../components/HJData';
import HJDataDeals from '../components/HJDataDeals';
import HJDataHosts from '../components/HJDataHosts';
import HJDataHotels from '../components/HJDataHotels';
import HJDataNearby from '../components/HJDataNearby';
import HJDataSociety from '../components/HJDataSociety';
import HJDetail from '../components/HJDetail';
import HJFooter from '../components/HJFooter';
import HJForm from '../components/HJForm';
import HJHeader from '../components/HJHeader';
import HJImageDemo from '../components/HJImageDemo';
import HJLegacy from '../components/HJLegacy';
import HJMap from '../components/HJMap';
import HJParallaxLayout from '../components/HJParallaxLayout';
import HJPropertyList from '../components/HJPropertyList';
import HJRedirect from '../components/HJRedirect';
import HJTab from '../components/HJTab';
import HJTabbedContentBlockList from '../components/HJTabbedContentBlockList';
import HJTestHeader from '../components/HJTestHeader';
import HJapi from '../components/HJapi';
import MyFirstComponent from '../components/MyFirstComponent';
import StyleguideComponentParams from '../components/Styleguide/Styleguide-ComponentParams';
import StyleguideCustomRouteType from '../components/Styleguide/Styleguide-CustomRouteType';
import StyleguideFieldUsageCheckbox from '../components/Styleguide/Styleguide-FieldUsage-Checkbox';
import StyleguideFieldUsageContentList from '../components/Styleguide/Styleguide-FieldUsage-ContentList';
import StyleguideFieldUsageCustom from '../components/Styleguide/Styleguide-FieldUsage-Custom';
import StyleguideFieldUsageDate from '../components/Styleguide/Styleguide-FieldUsage-Date';
import StyleguideFieldUsageFile from '../components/Styleguide/Styleguide-FieldUsage-File';
import StyleguideFieldUsageImage from '../components/Styleguide/Styleguide-FieldUsage-Image';
import StyleguideFieldUsageItemLink from '../components/Styleguide/Styleguide-FieldUsage-ItemLink';
import StyleguideFieldUsageLink from '../components/Styleguide/Styleguide-FieldUsage-Link';
import StyleguideFieldUsageNumber from '../components/Styleguide/Styleguide-FieldUsage-Number';
import StyleguideFieldUsageRichText from '../components/Styleguide/Styleguide-FieldUsage-RichText';
import StyleguideFieldUsageText from '../components/Styleguide/Styleguide-FieldUsage-Text';
import StyleguideLayoutReuse from '../components/Styleguide/Styleguide-Layout-Reuse';
import StyleguideLayoutTabsTab from '../components/Styleguide/Styleguide-Layout-Tabs-Tab';
import StyleguideLayoutTabs from '../components/Styleguide/Styleguide-Layout-Tabs';
import StyleguideLayout from '../components/Styleguide/Styleguide-Layout';
import StyleguideMultilingual from '../components/Styleguide/Styleguide-Multilingual';
import StyleguideRouteFields from '../components/Styleguide/Styleguide-RouteFields';
import StyleguideSection from '../components/Styleguide/Styleguide-Section';
import StyleguideSitecoreContext from '../components/Styleguide/Styleguide-SitecoreContext';
import StyleguideSpecimen from '../components/Styleguide/Styleguide-Specimen';
import StyleguideTracking from '../components/Styleguide/Styleguide-Tracking';
import _HJCarousel from '../components/_HJCarousel';

const components = new Map();
components.set('ContentBlock', ContentBlock);
components.set('GraphQL-ConnectedDemo', GraphQLConnectedDemo);
components.set('GraphQL-IntegratedDemo', GraphQLIntegratedDemo);
components.set('GraphQL-Layout', GraphQLLayout);
components.set('GraphQL-SSRDemo', GraphQLSSRDemo);
components.set('HJBook', HJBook);
components.set('HJCTA', HJCTA);
components.set('HJCalendar', HJCalendar);
components.set('HJContainer', HJContainer);
components.set('HJContentBlock', HJContentBlock);
components.set('HJContentBlockList', HJContentBlockList);
components.set('HJContentBlockListIntegrated', HJContentBlockListIntegrated);
components.set('HJContentModule', HJContentModule);
components.set('HJCountryBlock', HJCountryBlock);
components.set('HJData', HJData);
components.set('HJDataDeals', HJDataDeals);
components.set('HJDataHosts', HJDataHosts);
components.set('HJDataHotels', HJDataHotels);
components.set('HJDataNearby', HJDataNearby);
components.set('HJDataSociety', HJDataSociety);
components.set('HJDetail', HJDetail);
components.set('HJFooter', HJFooter);
components.set('HJForm', HJForm);
components.set('HJHeader', HJHeader);
components.set('HJImageDemo', HJImageDemo);
components.set('HJLegacy', HJLegacy);
components.set('HJMap', HJMap);
components.set('HJParallaxLayout', HJParallaxLayout);
components.set('HJPropertyList', HJPropertyList);
components.set('HJRedirect', HJRedirect);
components.set('HJTab', HJTab);
components.set('HJTabbedContentBlockList', HJTabbedContentBlockList);
components.set('HJTestHeader', HJTestHeader);
components.set('HJapi', HJapi);
components.set('MyFirstComponent', MyFirstComponent);
components.set('Styleguide-ComponentParams', StyleguideComponentParams);
components.set('Styleguide-CustomRouteType', StyleguideCustomRouteType);
components.set('Styleguide-FieldUsage-Checkbox', StyleguideFieldUsageCheckbox);
components.set('Styleguide-FieldUsage-ContentList', StyleguideFieldUsageContentList);
components.set('Styleguide-FieldUsage-Custom', StyleguideFieldUsageCustom);
components.set('Styleguide-FieldUsage-Date', StyleguideFieldUsageDate);
components.set('Styleguide-FieldUsage-File', StyleguideFieldUsageFile);
components.set('Styleguide-FieldUsage-Image', StyleguideFieldUsageImage);
components.set('Styleguide-FieldUsage-ItemLink', StyleguideFieldUsageItemLink);
components.set('Styleguide-FieldUsage-Link', StyleguideFieldUsageLink);
components.set('Styleguide-FieldUsage-Number', StyleguideFieldUsageNumber);
components.set('Styleguide-FieldUsage-RichText', StyleguideFieldUsageRichText);
components.set('Styleguide-FieldUsage-Text', StyleguideFieldUsageText);
components.set('Styleguide-Layout-Reuse', StyleguideLayoutReuse);
components.set('Styleguide-Layout-Tabs-Tab', StyleguideLayoutTabsTab);
components.set('Styleguide-Layout-Tabs', StyleguideLayoutTabs);
components.set('Styleguide-Layout', StyleguideLayout);
components.set('Styleguide-Multilingual', StyleguideMultilingual);
components.set('Styleguide-RouteFields', StyleguideRouteFields);
components.set('Styleguide-Section', StyleguideSection);
components.set('Styleguide-SitecoreContext', StyleguideSitecoreContext);
components.set('Styleguide-Specimen', StyleguideSpecimen);
components.set('Styleguide-Tracking', StyleguideTracking);
components.set('_HJCarousel', _HJCarousel);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
